import { useCurrentTier } from '@/hooks/useCurrentTier';
import { useCurrentOrganizationBilling } from '@/hooks/useSwr';
import AmexLogo from '@/icons/AmexLogo.svg?react';
import DiscoverLogo from '@/icons/DiscoverLogo.svg?react';
import JCBLogo from '@/icons/JCBLogo.svg?react';
import MastercardLogo from '@/icons/MastercardLogo.svg?react';
import UnionPayLogo from '@/icons/UnionPay.svg?react';
import VisaLogo from '@/icons/VisaLogo.svg?react';

import { useSetUpBillingHandlers } from '../PlansAndBillingV2/store/helpers';
import { BillingInfoCardActions } from './BillingInfoCardActions';
import { CancelButton } from './CancelButton';

const paymentMethodLogos = {
  visa: <VisaLogo />,
  unionpay: <UnionPayLogo />,
  mastercard: <MastercardLogo />,
  amex: <AmexLogo />,
  discover: <DiscoverLogo />,
  jcb: <JCBLogo />,
};

export function PaymentMethod(props: {
  setupPaymentTrigger?: () => void;
  isSetupPaymentMutating?: boolean;
}) {
  const { data: currentOrganization } = useCurrentOrganizationBilling();

  // this is for v2
  const { handleUpdatePaymentMethod, isMutating } = useSetUpBillingHandlers();

  const { tier } = useCurrentTier();
  if (!currentOrganization?.payment_method) return null;
  const { brand, last4, exp_year, exp_month } =
    currentOrganization.payment_method;

  const logo = brand ? paymentMethodLogos[brand] : null;

  return (
    tier !== 'free' && (
      <div className="flex flex-col gap-3">
        <div className="flex w-[500px] justify-between text-lg font-semibold">
          Billing
          <CancelButton
            endOfBillingPeriod={currentOrganization?.end_of_billing_period}
            currentOrganization={currentOrganization}
            currentTier={tier}
            isPersonal={currentOrganization.is_personal}
          />
        </div>
        <div className="flex w-[500px] justify-between gap-4 rounded-md border border-secondary p-3">
          <div className="flex items-start gap-4">
            {logo && (
              <div className="flex h-[40px] w-[58px] items-center rounded-md border border-secondary bg-white p-1">
                {logo}
              </div>
            )}
            {brand && last4 && exp_year && exp_month ? (
              <div className="flex flex-col gap-1 text-sm">
                <div className="flex items-center gap-1">
                  <span className="capitalize">{brand}</span>
                  <span>{`ending in ${last4}`}</span>
                </div>
                <div className="font-normal text-tertiary">
                  {`Expiry ${exp_month}/${exp_year}`}
                </div>
              </div>
            ) : (
              <div>Payment method successfully added</div>
            )}
          </div>
          <BillingInfoCardActions
            currentOrganization={currentOrganization}
            setupPaymentTrigger={() => {
              // do v1 or v2 trigger, not both
              if (props.setupPaymentTrigger) {
                props.setupPaymentTrigger?.();
                return;
              }
              handleUpdatePaymentMethod();
            }}
            isSetupPaymentMutating={props.isSetupPaymentMutating || isMutating}
          />
        </div>
      </div>
    )
  );
}
